import { defineStore } from 'pinia'
import { api } from 'boot/receiver/axios'

import type { SuccessApiRes, SuccessPaginationRes } from 'types/common/api'
import type { NotifList, NotifType } from 'types/common/notifications'
import { useErrorStore } from 'src/stores/common/error'

export const useNotificationsStore = defineStore('notifications', {
  state: () => ({
    lastNotifications: null as NotifType[] | null,
    notifCount: 0,
    newNotif: 0,
  }),

  actions: {
    async fetchLastNotifications() {
      try {
        const res = await api.get('/account/notifications')
        const data: SuccessApiRes<NotifList> = res?.data

        if (data.success) {
          this.lastNotifications = data.payload.list
          this.notifCount = data.payload.count
          this.newNotif = data.payload.new

          return true
        } else return false
      } catch (error) {
        useErrorStore().updateBackErrors(error)
        return false
      }
    },

    async fetchNotifications(page: number, per_page = 20) {
      try {
        const res = await api.get('/account/notifications/all', {
          params: {
            page,
            per_page,
          },
        })

        const data: SuccessPaginationRes<NotifType> = res.data
        if (data.success) {
          return data.payload
        } else return false
      } catch (error) {
        useErrorStore().updateBackErrors(error)
        return false
      }
    },

    async removeNotification(notificationId: string) {
      try {
        const res = await api.delete(`/account/notification/${notificationId}`)

        return res.status >= 200 && res.status < 300
      } catch (error) {
        useErrorStore().updateBackErrors(error)
        return false
      }
    },
  },
})
